import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_amc.my_last_reimbursement.title',
  },
  lossDate: {
    id: 'dashboard_amc.claim.loss_date',
  },
  amount: {
    id: 'dashboard_amc.claim.amount',
  },
  seeDetails: {
    id: 'dashboard_auto.last_sinister.see_details',
  },
  actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  enCours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  emptyState: {
    id: 'amc.last.refund.empty.state',
  },
  claimNumber: {
    id: 'dashboard_amc.contract.claim_number',
  },
  statusAgrement: {
    id: 'amc_details.my_refunds.status_agrement',
  },
  statusReturn: {
    id: 'amc_details.my_refunds.status_return',
  },
  statusVisite: {
    id: 'amc_details.my_refunds.status_visite',
  },
  statusRejected: {
    id: 'amc_details.my_refunds.status_rejected',
  },
  statusPaid: {
    id: 'amc_details.my_refunds.status_paid',
  },
  statusPecCanceled: {
    id: 'amc_details.my_refunds.status_pec_canceled',
  },
  statusPending: {
    id: 'amc_details.my_refunds.status_pending',
  },
  statusComplementaryInfo: {
    id: 'amc_details.my_refunds.status_complementary_info',
  },
  statusPendingComplementaryInfo: {
    id: 'amc_details.my_refunds.status_complementary_info_pending',
  },
  statusPec: {
    id: 'amc_details.my_refunds.status_pec',
  },
  statusSSuite: {
    id: 'amc_details.my_refunds.status_s_suite',
  },
  benficiairy: {
    id: 'amc_details.my_refunds.beneficiary',
  },
});
